import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import TableHeader from "./table-header";
import UISimpleTableSkeleton from "./table-skeleton";
import NoDataRow from "./no-data-row";

const UISimpleTable = ({
  columns,
  children,
  containerStyles = {},
  tableStyles = {},
  containerClass = "",
  tableClass = "",
  stickyHeader = false,
  loading = false,
  hasData = true,
  noDataMessage = "No data available",
  withBody = true,
  onSort,
  showFilters = false,
  filterValues = {},
  onFilterChange = () => {},
}) => {
  return (
    <TableContainer
      className={containerClass}
      component={Paper}
      elevation={0}
      sx={{ ...containerStyles, borderColor: "var(--palette-stroke)" }}
    >
      <Table
        stickyHeader={stickyHeader}
        className={tableClass}
        sx={{ 
          minWidth: 100, 
          ...tableStyles,
          "& td:first-of-type": { pl: "16px !important" },
          "& th:first-of-type": { pl: "16px !important" },
        }}
        aria-label="simple table"
      >
        <TableHeader
          columns={columns}
          onSort={onSort}
          showFilters={showFilters}
          filterValues={filterValues}
          onFilterChange={onFilterChange}
        />
        {/* <TableBody>{children}</TableBody> */}
        {loading ? <UISimpleTableSkeleton columns={columns} /> : children}
        {!hasData && !loading && (
          <NoDataRow
            columnsLength={columns.length}
            message={noDataMessage}
            withBody={withBody}
          />
        )}
      </Table>
    </TableContainer>
  );
};

export const UISimpleTableCell = ({
  children,
  align = "center",
  sx,
  ...rest
}) => (
  <TableCell
    align={align}
    {...rest}
    sx={{
      background: "var(--palette-container)",
      borderColor: "var(--palette-stroke)",
      color: "var(--palette-text)",
      ...sx,
    }}
  >
    {children}
  </TableCell>
);

export default UISimpleTable;
